export default "__VITE_ASSET__02876cd9__"